<template>
	<div class="p4">
		<!-- Display form based on schema -->
		<div v-for="field in computedSchema" class="mb6">
			<core-form-input
				:name="field.label"
				:componentName="field.component"
				:label="field.label"
				v-model="form[field.bindTo]"
				v-bind="field.props"
			/>
		</div>

		<!-- Button -->
		<div class="xs-12 flex xs-between">
			<j-button @click="createTransaction" :isLoading="isLoading">
				Create
			</j-button>
			<j-button @click="$emit('transaction:canceled')" type="bordered">
				Cancel
			</j-button>
		</div>
	</div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton"
import JSpinner from "@/components/JSpinner"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: { CoreFormInput, JButton, JSpinner },

	props: {
		policyId: String,
		endorsementId: String,

		schema: {
			type: Array,
			default: () => []
		}
	},

	data() {
		return {
			isLoading: false,
			transactionId: "",

			// v-model will bind here
			form: {
				"transaction.amount": 0
			}
		}
	},

	computed: {
		computedSchema() {
			return this.schema.map(item => ({
				...item,
				// last part of bindTo
				model: item?.bindTo?.split(".")?.slice(-1)?.[0] || ""
			}))
		}
	},

	methods: {
		async createTransaction() {
			const query = gql`
				mutation createTransaction($input: createTransactionInput!) {
					createTransaction(input: $input) {
						status
						errors
						createdStatus {
							id
						}
					}
				}
			`

			// Validate if amount is there
			if (this.form["transaction.amount"] === null) {
				this.$store.dispatch("showError", "Amount field is required")
				return
			}

			// Collect facts from schema
			const factFields = this.computedSchema.filter(item =>
				item.bindTo.includes("transaction.facts")
			)

			// Collect root fields from schema
			const rootFields = this.computedSchema.filter(
				item => !item.bindTo.includes("transaction.facts")
			)

			const rootFieldsWithValues = {}
			rootFields.forEach(item => {
				rootFieldsWithValues[item.model] = this.form[item.bindTo]
			})

			this.isLoading = true
			const res = await api({
				query,
				variables: {
					input: {
						policyId: this.policyId,
						endorsementId: this.endorsementId || null,
						// Root fields
						...rootFieldsWithValues
					}
				}
			})

			// Check errors
			if (res?.data?.createTransaction?.status !== "success") {
				this.$store.dispatch(
					"showError",
					"Transaction was added partially, please add it again"
				)

				// Emit
				this.$emit("transaction:added")
				this.isLoading = false
				return
			}

			const transactionId =
				res?.data?.createTransaction?.createdStatus?.id || ""

			//2: Add all facts to transaction
			const addedFacts = await Promise.all([
				...factFields.map(item =>
					this.addFactToTransaction(transactionId, {
						type: item.model,
						value: {
							[item.scalarDataType || "stringValue"]: this.form[item.bindTo]
						}
					})
				)
			])

			this.$emit("transaction:added")
			this.isLoading = false
		},

		async addFactToTransaction(transactionId, input) {
			const query = gql`
				mutation addFactToTransaction(
					$transactionId: String!
					$input: addFactInput!
				) {
					addFactToTransaction(transactionId: $transactionId, input: $input) {
						status
						errors
						createdStatus {
							id
						}
					}
				}
			`

			const res = await api({
				query,
				variables: {
					transactionId,
					input
				}
			})

			return Promise.resolve(res)
		}
	},

	created() {
		// this.createTransaction()
	}
}
</script>
